export default __webpack_public_path__ + "static/logo-welireg-900a9760726d140d95b0f74ccba7f77b.svg";